import { render, staticRenderFns } from "./AccountPage.vue?vue&type=template&id=2fdb3b92&scoped=true&"
import script from "./AccountPage.vue?vue&type=script&lang=js&"
export * from "./AccountPage.vue?vue&type=script&lang=js&"
import style0 from "./AccountPage.vue?vue&type=style&index=0&id=2fdb3b92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb3b92",
  null
  
)

export default component.exports